import React, { useState, useEffect } from 'react';
import UsersList from './UsersList';
import UserHeader from './UsersHeader';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCompanyUsersStatus } from '../store/user.selectors';
import { fetchAllUsers, resetEdit } from '../store/user.actions';

const Users = () => {
  const dispatch = useDispatch();
  const status = useSelector(getAllCompanyUsersStatus);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    dispatch(resetEdit());
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (status === 'idle') dispatch(fetchAllUsers());
  }, [status, dispatch]);

  useEffect(() => {
    dispatch(resetEdit());
  }, []);

  return (
    <>
      <UserHeader
        isModalOpen={isModalOpen}
        handleOpenModal={handleOpenModal}
        handleCloseModal={handleCloseModal}
      />
      <UsersList handleOpenModal={handleOpenModal} />
    </>
  );
};

export default Users;
